import { apiRoutes } from 'config/apiRoutes'
import axios from 'libs/fetch'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseMarkAsConfirmedProps = {
	id: number | undefined
}

export const useMarkAsConfirmed = ({ id }: UseMarkAsConfirmedProps) => {
	const queryClient = useQueryClient()
	const { t } = useTranslation()

	const { mutate: markAsConfirmedMutation, isPending: isMarkAsConfirmedPending } = useMutation({
		mutationFn: (id: number) => axios.post(apiRoutes.bookingMarkAsConfirmed(id.toString())),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Booking marked as confirmed')
			})()

			if (id) {
				queryClient.invalidateQueries({ queryKey: queryKeys.bookings.detail(id.toString()) })
			}
		},
		onError: (err: any) => {
			useToast({
				type: 'error',
				message: err.response?.data?.detail ?? t('Something went wrong')
			})()
		}
	})

	return {
		markAsConfirmedMutation,
		isMarkAsConfirmedPending
	}
}
